import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { t } from '../translations';

// The styled "Subscribe to our events newsletter HERE!" line, shown above
// the panels on /events and in the halftone band on the home page.
// `padding` lets each page balance its own surrounding whitespace.
function NewsletterLink({ padding = '6px 20px' }) {
  const { language } = useLanguage();
  return (
    <div style={{ textAlign: 'center', padding }}>
      <a
        href="https://ideafarm.eo.page/newsletter"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: '#191919',
          textDecoration: 'none',
          fontFamily: "'Jost','Futura',sans-serif",
          fontWeight: 500,
          letterSpacing: '3.5px',
          fontSize: '1.45rem'
        }}
      >
        {t('newsletter.linkText', language)}{' '}
        <span style={{ textDecoration: 'underline', textUnderlineOffset: '3px' }}>
          {t('newsletter.linkHere', language)}
        </span>
        !
      </a>
    </div>
  );
}

export default NewsletterLink;
